module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 84.e1373bd3.png";